<div class="box info-box">
  <h3>Ihr Beitrag</h3>
  <p>
    Name: <span class="text--bold">{{ firstName }} {{ lastName }}</span>
  </p>
  <p>
    Kundennummer: <span class="text--bold">{{ customerNumber }}</span>
  </p>
  <hr />
  <p>
    Gesamtbeitrag: <span class="text--bold">{{ amountInEuro | currency: 'EUR' : 'code' : '1.2-2' }}</span>
  </p>
</div>
